import { STATE_NAMES } from "encamp-shared/src/constants/states";
import { MANAGEMENT_METHOD_CODE_DESCRIPTIONS } from "encamp-shared/src/waste/validCodes";

// Look-ups keyed by the raw omnisearch string value. An `enumPresentationFunction`
// receives a plain `string` (the emitted term value), so a Map avoids the
// `value as keyof typeof …` casts that direct record indexing would require —
// mirroring the MIXED_LIST_SOURCE_LABEL_BY_VALUE pattern in manifestSourceDisplay.ts.
const STATE_NAME_BY_ABBREV = new Map<string, string>(Object.entries(STATE_NAMES));
const MGMT_METHOD_DESC_BY_CODE = new Map<string, string>(
  Object.entries(MANAGEMENT_METHOD_CODE_DESCRIPTIONS)
);

/** "California (CA)" for a known state/territory abbreviation; the raw value otherwise. */
export function stateOptionLabel(value: string): string {
  const name = STATE_NAME_BY_ABBREV.get(value);
  return name ? `${name} (${value})` : value;
}

/** "H132 · Landfill" for a known EPA management method code; the raw value otherwise. */
export function managementMethodCodeOptionLabel(value: string): string {
  const description = MGMT_METHOD_DESC_BY_CODE.get(value);
  return description ? `${value} · ${description}` : value;
}
